module.exports = __webpack_public_path__ + "static/img/appStart.8f8a6bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/appStart.png
// module id = 1jL5
// module chunks = 1